import { Shield, Users, Building2, HardHat } from "lucide-react";
import Logo from "../assets/logo2.jpg";

export default function AdminLanding() {
  const cards = [
    {
      title: "Super Admin",
      desc: "Centralized control for masters, configurations, permissions, and system governance.",
      href: "/admin/login?role=super_admin",
      icon: <Shield className="h-6 w-6" />,
      accent: "bg-blue-600 hover:bg-blue-700",
      ring: "hover:border-blue-400/50",
    },
    {
      title: "Admin",
      desc: "Manage materials, payroll, employees, and day-to-day operational workflows.",
      href: "/admin/login?role=admin",
      icon: <Users className="h-6 w-6" />,
      accent: "bg-emerald-600 hover:bg-emerald-700",
      ring: "hover:border-emerald-400/50",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-100 text-gray-900">
      {/* Header bar — same role as HeaderBar on Admin Home */}
      <div className="bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img
              src={Logo}
              alt="Infraconsoft V5"
              className="h-12 w-12 rounded-lg shadow object-cover"
            />
            <div>
              <h1 className="font-dmserif text-2xl md:text-3xl leading-tight">
                ADMIN HOME
              </h1>
              <p className="text-xs text-gray-500">Infraconsoft V5</p>
            </div>
          </div>

          <div className="hidden sm:flex items-center gap-4 text-sm text-gray-500">
            <span className="inline-flex items-center gap-2">
              <Building2 className="h-4 w-4 text-blue-500" />
              Projects
            </span>
            <span className="inline-flex items-center gap-2">
              <HardHat className="h-4 w-4 text-emerald-500" />
              Workforce
            </span>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 py-8">
        {/* Main panel — same shell as Admin Home */}
        <div className="p-6 rounded-2xl shadow-xl border bg-white border-gray-200">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div>
              <h2 className="text-2xl font-bold text-gray-900">
                Welcome to Admin Panel
              </h2>
              <p className="text-gray-600 mt-1">
                Choose a module to manage system configuration.
              </p>
            </div>
          </div>

          {/* Cards — Admin Home card pattern */}
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {cards.map((c) => (
              <a
                key={c.title}
                href={c.href}
                className={`text-left rounded-2xl border p-5 shadow-md hover:shadow-xl transition-all duration-200 transform hover:-translate-y-1 bg-gray-50 border-gray-200 hover:bg-white ${c.ring}`}
              >
                <div className="flex items-start gap-3">
                  <div
                    className={`w-12 h-12 rounded-xl flex items-center justify-center text-white shadow-lg shrink-0 ${c.accent}`}
                  >
                    {c.icon}
                  </div>

                  <div>
                    <h3 className="font-semibold text-lg text-gray-900">
                      {c.title}
                    </h3>
                    <p className="text-sm mt-1 leading-relaxed text-gray-600">
                      {c.desc}
                    </p>
                  </div>
                </div>
              </a>
            ))}
          </div>

          <p className="mt-8 text-center text-xs text-gray-400">
            A next-generation Construction ERP for project control, inventory,
            payroll, and enterprise operations.
          </p>
        </div>

        <p className="text-center mt-8 text-xs text-gray-500">
          © {new Date().getFullYear()} Infraconsoft V5 · Construction ERP Platform
        </p>
      </div>
    </div>
  );
}